import { FC } from "react";
import useCustomTranslation from "common/hooks/useCustomTranslation";
import commonKeysConfig from "common/config/common-keys.config";

import { useGetDisclaimerContentQuery } from "modules/home/redux/queries";

import "./DisclaimerBanner.scss";

const DisclaimerBanner: FC = () => {
  const { t } = useCustomTranslation(["home", "common"]);

  const { data: disclaimerData, isFetching } = useGetDisclaimerContentQuery();

  return (
    <div className="disclaimer-banner" tabIndex={-1}>
      <p className="disclaimer-banner__heading">
        {t(commonKeysConfig.disclaimerText)}
      </p>

      {isFetching ? (
        <>
          <div className="motif-skeleton-12 banner-text-loader" />
          <div className="motif-skeleton-12 banner-text-loader" />
          <div className="motif-skeleton-8 banner-text-loader" />
        </>
      ) : (
        <p className="disclaimer-banner__text">{disclaimerData?.disclaimer}</p>
      )}
    </div>
  );
};

export default DisclaimerBanner;
